<div class="container">
    <div class="padding-top-60 padding-bottom-60">
        <img src="/assets/images/ui/logo-infomaniak.svg" />
    </div>
    <div class="blocks-container padding-bottom-100">
        <div class="left">
            <app-signup-left-block></app-signup-left-block>
        </div>
        <div class="spacer"></div>
        <div class="right">
            <app-signup-right-block></app-signup-right-block>
        </div>
    </div>

    
    
</div>

<div class="footer">
        <div class="footer-block">
            <div class="footer-block-title">
                <img src="/assets/images/ui/logo-infomaniak-dark-grey.svg" />
            </div>
            <div class="footer-block-desc">
                <img src="/assets/images/ui/ethical_cloud.svg" />
            </div>
            <div class="footer-block-cgu">
               <span (click)="launchCGU()">{{'Conditions generales d\'utilisation' | transloco}}</span>
            </div>
        </div>
    </div>
